export default {
  确定: 'Confirm',
  取消: 'Cancel',
  重置: 'Reset',
};
